import { render, staticRenderFns } from "./StudentHomeworkReportWidget.vue?vue&type=template&id=2d55a42a"
import script from "./StudentHomeworkReportWidget.vue?vue&type=script&lang=js"
export * from "./StudentHomeworkReportWidget.vue?vue&type=script&lang=js"
import style0 from "./StudentHomeworkReportWidget.vue?vue&type=style&index=0&id=2d55a42a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports